// Attribution: https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-react#sign-users-out

// Dependencies
import React, { useCallback } from 'react';

// MSAL
import { useMsal } from '@azure/msal-react';
import { loginRequest } from 'configs/authConfig';

// Material
import Button from '@mui/material/Button';

/**
 * Renders a button which, when selected, will redirect the page to the logout prompt
 */
const SignOutButton = () => {
	const { instance } = useMsal();

	// Signout button click event handler
	const handleLogout = useCallback(
		() => {
			// clear local cached items
			sessionStorage.clear();
			// use redirect
			instance
				.logoutRedirect(loginRequest)
				.catch((e) => {
					console.error(e);
				});
		},
		[instance]
	);

	return (
		<Button
			size="small"
			variant="outlined"
			color="secondary"
			sx={{ overflow: 'hidden', textTransform: 'none' }}
			onClick={handleLogout}
		>
			Sign Out
		</Button>
	);
};

export { SignOutButton };
